import React from 'react';
import cx from 'classnames';
import {Title} from '@priority-software/priority-style-react';
import {texts} from '../Announcement/data/texts';
import styles from './UpgradeDialog.module.scss';

export const DialogHeader = ({slide}: {slide: number}) => {
    const title = slide === 1 ? texts.upcomingUpgrade : texts.stayUpdated;
    return (
        <Title
            skin="h3"
            text={title}
            textColor="primary-700"
            fontWeight="bold"
            componentClasses={cx({[styles.dialogHeader]: slide === 1})}
        />
    );
};
